import { render, staticRenderFns } from "./loader.component.vue?vue&type=template&id=88c7aafa&scoped=true&"
import script from "./loader.component.vue?vue&type=script&lang=js&"
export * from "./loader.component.vue?vue&type=script&lang=js&"
import style0 from "./loader.component.vue?vue&type=style&index=0&id=88c7aafa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c7aafa",
  null
  
)

export default component.exports